import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate, useParams } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import { Layout, Col, Row, DatePicker } from "antd";
import { Button, Card, Form, Spin } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  CREATE_ROOM_BLOCKED,
  EDIT_ROOM_BLOCKED,
  ROOM_BLOCKED_BY_ID,
} from "../../constants/api";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function RoomBlockedManage() {
  const { Content } = Layout;
  const { room_id, edit_id } = useParams();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    if (edit_id) {
      getIdDetail();
    }
  }, []);

  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("id", edit_id);
    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          id: edit_id,
          room_id: room_id,
          from_date: dayjs(data.data.from_date),
          to_date: dayjs(data.data.to_date),
        });

        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(ROOM_BLOCKED_BY_ID, data, successFn, errorFn);
  };

  const submitData = (values) => {
    setIsLoading(true);
    const jsonData = {
      room_id: room_id,
      from_date: dayjs(values.from_date).add(330, "minutes"),
      to_date: dayjs(values.to_date).add(330, "minutes"),
    };
    if (edit_id) {
      jsonData.id = edit_id;
    }
    const successFn = function (data) {
      if (data.status) {
        setIsLoading(false);
        navigate(-1);
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(
      edit_id ? EDIT_ROOM_BLOCKED : CREATE_ROOM_BLOCKED,
      jsonData,
      successFn,
      errorFn
    );
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Spin spinning={loading}>
            <Card
              title="Manage Blocked"
              bordered={false}
              extra={
                <Button
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => navigate(-1)}
                  type="primary"
                  ghost
                >
                  <RollbackOutlined />
                </Button>
              }
            >
              <Form form={form} layout="vertical" onFinish={submitData}>
                <Form.Item name="id" hidden />
                <Form.Item name="room_id" hidden />
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      name="from_date"
                      label="From date"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          required: true,
                          message: "From date is required!",
                        },
                      ]}
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="to_date"
                      label="To date"
                      style={{ width: "100%" }}
                      rules={[
                        {
                          required: true,
                          message: "To date is required!",
                        },
                      ]}
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Spin>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default RoomBlockedManage;
